import React, { useEffect, useRef, useState } from 'react'
import './EventDetailsBody.scss'
import { Body, Title } from '@vds/typography'
import CoursePreview from '../../CourseDetailsPage/CoursePreview/CoursePreview'
import CourseDetailsSection from '../../CourseDetailsPage/CourseDetailsSection/CourseDetailsSection'
import RelatedSection from '../../CourseDetailsPage/RelatedSection/RelatedSection'
import EventPreview from '../EventPreview/EventPreview'
import EventWidget from '../EventWidget/EventWidget'
import DOMPurify from 'dompurify';
import { getInfoHubHtml } from '../../../utility/common';
import { Helmet } from 'react-helmet';
import {decodeHTML, getImageToBeRendered, mapTopicsAndTags, TAG_RECORDED_EVENTS} from '../../../utility/utils'
import { isMobile, isTablet, isDesktop } from 'react-device-detect';
import { Content_View, pageLoadCompleted, pageLoadStarted } from '../../../common/Analytics/GAWrapper'
import { Icon } from '@vds/icons';
import InPersonEventWidget from '../../InPersonEventDetailsPage/InPersonEventWidget/InPersonEventWidget'
import { TextLink } from '@vds/buttons'
import { useSelector } from 'react-redux'

const EventDetailsBody = ({ isInPersonEvent, currentInPersonEvent, eventStatus, aemOffersContentForHeading, selectedTopics, currentCourse, topicEnEsMaping, allCourses, allQuickTips,allIPEventsWithTimezone, allEventsWithTimeZone, offersMock, courseType, eventCxAemData, isRecorded, formattedCurrentEvent }) => {
  let { isBefore, isAfter, isDuring } = eventStatus;
  const previewRef = useRef(null);
  const detailsRef = useRef(null);
  const relatedRef = useRef(null);
  const supportRef = useRef(null);
  const overviewRef = useRef(null);
  const videoRef = useRef(null);
  const widgetRef = useRef(null);
  const videoGARef = useRef(null);
  const [showControls, setShowControls] = useState(false);
  const [relSectionPillData, setRelSectionPillData] = useState(null);
  const [hideRelSection, setHideRelSection] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(true);

  const imgFormat = useSelector((state) => state?.Aem?.imgFormat) ?? 'avif';

  // const [activeTab, setActiveTab] = useState(isRecorded && isBefore ? 'overview' : 'preview');
  const [eventInFifteen, setEventInFifteen] = useState(false);
  const [videoError, setVideoError] = useState(false);
  const [previewURL, setPreviewURL] = useState({ vidURL: null, imgURL: null });
  const screenType = isDesktop ? "desktop" : isTablet ? "tablet" : isMobile ? "mobile" : "desktop";
  let id = currentCourse?.id?.split(":")[1];
  const lng = localStorage.getItem("lng") ?? 'en';
  let aemConfigData = localStorage.getItem('aemConfigData') ? JSON.parse(localStorage.getItem('aemConfigData')) : null;
  const [posterImage, setPosterImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [aemSupportData, setAemSupportData] = useState(null);
  const [isPageLoaded,setIsPageLoaded] = useState(true);
  const [previewDetails, setPreviewDetails] = useState(null);
  const courseTitleEnEs = allEventsWithTimeZone?.find(event => event.id === currentCourse?.id)?.title;
  let filteredDetails = null;
  const [activeTab, setActiveTab] = useState(() => {
    if (isAfter || (isInPersonEvent && isAfter)) {
      return 'related'; // Default tab for "after" state
    } else if (isRecorded && (isBefore || isAfter)) {
      return 'overview'; // Default tab for "recorded" and "before" state
    } else if (isInPersonEvent) {
      return 'preview'; // Default tab for In-Person events
    } else {
      return 'preview'; // Default tab for other states
    }
  });

  const handleViewOnMapClick = (e, inPersonLocation) => {
    e.preventDefault();
  
    const mapUrl = inPersonLocation?.mapUrl;
    const address = inPersonLocation?.address;
    const city = inPersonLocation?.city;
    const state = inPersonLocation?.state;
    const zipCode = inPersonLocation?.zipCode;
  
    // Construct the full address if available
    const fullAddress = `${address ? address + ', ' : ''}${city ? city + ', ' : ''}${state ? state + ' ' : ''}${zipCode ? zipCode : ''}`;
  
    if (isMobile || isTablet) {
      // Attempt to open the native maps app
      const nativeMapUrl = `geo:0,0?q=${encodeURIComponent(fullAddress)}`;
      window.location.href = nativeMapUrl;
  
      // Fallback to Google Maps in browser if native maps app is unavailable
      setTimeout(() => {
        if (!document.hasFocus()) return; // If the native app opened, do nothing
        if (mapUrl) {
          window.open(mapUrl, '_blank');
        } else {
          window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`, '_blank');
        }
      }, 500);
    } else if (isDesktop) {
      // Open Google Maps in a new tab for desktop
      if (mapUrl) {
        window.open(mapUrl, '_blank');
      } else {
        window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`, '_blank');
      }
    }
  };

  /*   const getTabs = () => {
    let baseTabs = [
      { name: 'Details', id: 'details', ref: detailsRef },
      { name: 'Related', id: 'related', ref: relatedRef },
      { name: 'Support', id: 'support', ref: supportRef },
    ];
    if (isRecorded && isBefore) {
      baseTabs.unshift({ name: 'Overview', id: 'overview', ref: overviewRef });
    } else if (!isAfter) {
      baseTabs.unshift({ name: 'Preview', id: 'preview', ref: previewRef });
    } else {
      // Swap Details and Related if isAfter is true
      [baseTabs[0], baseTabs[1]] = [baseTabs[1], baseTabs[0]];
    }
    return baseTabs;
  }; */
  const getTabs = () => {
    const tabNameMap = eventCxAemData?.overalltabs?.tabdetails.reduce((map, tab) => {
      map[tab.tabkey.toLowerCase()] = tab.tabname;
      return map;
    }, {});

    let baseTabs = hideRelSection ? [
      { name: tabNameMap["details"], id: "details", ref: detailsRef },
      { name: tabNameMap["support"], id: "support", ref: supportRef },
    ] : [
      { name: tabNameMap["details"], id: "details", ref: detailsRef },
      { name: tabNameMap["related"], id: "related", ref: relatedRef },
      { name: tabNameMap["support"], id: "support", ref: supportRef },
    ];
  
    if (isRecorded && (isBefore || isAfter)) {
      baseTabs.unshift({
        name: tabNameMap["overview"],
        id: "overview",
        ref: overviewRef,
      });
    } else if (!isAfter) {
      baseTabs.unshift({
        name: tabNameMap["preview"],
        id: "preview",
        ref: previewRef,
      });
    }  else if (isInPersonEvent && !isAfter) {
      baseTabs.unshift({
        name: tabNameMap["preview"],
        id: "preview",
        ref: previewRef,
      });
    } else {
      [baseTabs[0], baseTabs[1]] = [baseTabs[1], baseTabs[0]];
    }

    return baseTabs;
  };

  useEffect(() => {
    const tabs = getTabs();
    setTabs(tabs);
    // Dynamically set activeTab to the id of the first tab
    if (tabs.length > 0) {
      setActiveTab(tabs[0].id);
    }
  }, [isAfter, isRecorded, isBefore, isInPersonEvent, eventCxAemData, hideRelSection]);

  const [tabs, setTabs] = useState(getTabs());
  // Set activeTab to 'overview' if isRecorded and isBefore, otherwise 'preview'
  // useEffect(() => {
  //   setTabs(getTabs());
  //   if (isRecorded && isBefore) {
  //     setActiveTab('overview');
  //   } else {
  //     setActiveTab('preview');
  //   }
  // }, [isAfter, isRecorded, isBefore]);

  const handleTabClick = (id, ref) => {
    //setActiveTab(id);
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Focus the first interactive element for the  clicked section, skipping the plus icon
      const firstInteractiveElement = ref.current.querySelector(
        ' a, button:not(.button-icon-plus), input, select, textarea, [tabindex]:not([tabindex="-1"]):not([aria-hidden="true"],h3)'
        );
        if (firstInteractiveElement) {
           firstInteractiveElement.focus();
         }
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsPageLoaded(false);
    }
    window.addEventListener('scroll', handleScroll);
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };

    const observedSections = new Set();

    const observerCallback = (entries) => {
      const visibleEntries = entries.filter(entry => entry.isIntersecting);
      if (visibleEntries.length > 0) {
        visibleEntries.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        //setActiveTab(visibleEntries[0].target.id);
      }
      let allTopicsData = [];
      let allTopicsEnEs=[];
      eventCxAemData?.allTopics?.allTopicsData?.map((item) => {
        allTopicsData.push(item?.value?.toLowerCase().split(' ').join(''));
        allTopicsEnEs[item?.value?.toLowerCase().split(' ').join('')]=item?.label;
      });
      entries.forEach((entry) => {
        if (!isPageLoaded && entry.isIntersecting) {
          const sectionId = entry.target.id;
          let sectionName = sectionId;
          let linkText = currentCourse?.title;
          let linkUrl = window?.location?.href;
          let contentCategory = '';
          let topics = currentCourse?.tags.join(",");

          if (entry.target.id == 'widget') {
            contentCategory = 'event_widget_body_complete';
          } else if (entry.target.id == 'video') {
            contentCategory = 'event_page_sub_section';
          }else if (entry.target.id == 'myVideo') {
            contentCategory = 'event_page_sub_section';
          } else {
            sectionName = entry.target.getAttribute('data-section-name');
            linkText = entry.target.getAttribute('data-link-text');
            linkUrl = entry.target.getAttribute('data-link-url');
            topics = entry.target.getAttribute('data-topics');
            contentCategory = entry.target.getAttribute('data-content-category');
          }
          let splitTopics = topics?.split(',').map(str => str.trim())
          const translatedTopic = splitTopics?.map(tag =>
            topicEnEsMaping?.find(mapping => mapping[1] === tag)?.[2] || tag
          );
          let updatedTopics = [];
          splitTopics?.map(item=>{
              if(allTopicsData?.includes(item?.toLowerCase()?.split(' ')?.join(''))){
                updatedTopics.push(allTopicsEnEs[item?.toLowerCase()?.split(' ')?.join('')])
              }
          })
          if (!observedSections.has(sectionId)) {
            observedSections.add(sectionId);

            // Trigger the Content_View 
            Content_View(
              sectionName,
              linkUrl,
              updatedTopics?.length > 0 ? updatedTopics : '',
              contentCategory
            );
          }

          //setActiveTab(sectionId); // Update the active tab
        }
      });
    };

     // Create a single IntersectionObserver to handle lengthy sections
     const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const sectionHeight = entry.target.offsetHeight;
        const dynamicThreshold = sectionHeight > window.innerHeight ? 0.2 : 0.6;
  
        // Dynamically adjust the threshold for each section
        if (entry.intersectionRatio >= dynamicThreshold) {
          observerCallback([entry]);
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: Array.from({ length: 11 }, (_, i) => i / 10), // Use multiple thresholds for finer control
    });

    tabs.forEach(tab => {
      if (tab.ref.current) {
        tab.ref.current.setAttribute('data-section-name', tab?.name);
        tab.ref.current.setAttribute('data-link-text', `${currentCourse?.title}`);
        tab.ref.current.setAttribute('data-link-url', `${window?.location?.href}`);
        tab.ref.current.setAttribute('data-topics', `${currentCourse?.tags}`);
        tab.ref.current.setAttribute('data-content-category', 'event_page_sub_section');
        observer.observe(tab.ref.current);
      }
    });

    if (widgetRef.current) {
      observer.observe(widgetRef.current);
    }

    if (videoGARef?.current && videoGARef.current.id === 'video') {
      observer.observe(videoGARef.current);
    }
    if (videoRef?.current && videoRef.current.id === 'myVideo') {
      observer.observe(videoRef.current);
    }

    return () => {
      tabs.forEach(tab => {
        if (tab.ref.current) {
          observer.unobserve(tab.ref.current);
        }
      });
      if (widgetRef?.current) {
        observer.unobserve(widgetRef.current);
      }
      if (videoGARef?.current) {
        observer.unobserve(videoGARef.current);
      }
    };
  }, [tabs, widgetRef, videoGARef, isPageLoaded]);

  useEffect(() => {
    let aemEventSupportURL = "";
    if(isInPersonEvent){
      aemEventSupportURL = `${global.config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${global.config.aemUrlEnv}/${lng}/inperson_details/support/master.html`;
    }else{
      aemEventSupportURL = `${global.config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${global.config.aemUrlEnv}/${lng}/event_details/support/master.html`;
    }
    getInfoHubHtml(aemEventSupportURL)
      .then((response) => { setAemSupportData(response?.data) })
  }, [lng]);

  useEffect(() => {
    if (!aemSupportData) return;
    const existingSwiper = document.querySelector('script[src*= "swiper-bundle.min.js"]');
    const existingExplore = document.querySelector('script[src*= "courseDetCustSuprt.js"]');
    let swiperScript, script;
    if (!existingSwiper) {
      swiperScript = document.createElement('script');
      swiperScript.src = `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${global.config.aemUrlEnv === "QA1" ? '/QA1' : ''}/js/swiper-bundle.min.js`;
      swiperScript.type = 'text/javascript';
      swiperScript.async = false;
      document.body.appendChild(swiperScript);
    }

    if (!existingExplore) {
      script = document.createElement('script');
      script.src = `${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${global.config.aemUrlEnv === "QA1" ? '/QA1' : ''}${aemConfigData?.minifiedPath || ''}/js/courseDetCustSuprt${aemConfigData?.minifiedExt || ''}.js`;
      script.type = 'text/javascript';
      script.async = false;
      document.body.appendChild(script);
    }

    return () => {
      if (swiperScript) {
        document.body.removeChild(swiperScript);
      }
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, [aemSupportData]);

  const eventPreviewCardData = [
    {
      id: 1,
      icon: 'ideas-solutions',
      title: "This event is ideal for:",
      description: ["People looking to familiarize themselves with [topic], and gain a basic understanding of [topic] and [topic]."]
    },
    {
      id: 2,
      icon: 'education',
      title: "At the end of this event, you'll have the tools to:",
      description: [
        "Bullet point lorem ipsum dolor 1",
        "Bullet point lorem ipsum dolor 2",
        "Bullet point lorem ipsum dolor 3"
      ]
    },
    {
      id: 3,
      icon: 'services',
      title: "Event format: Ask the experts",
      description: ["Expert workshops by industry leaders with a focus on Q&A to help you get answers to your specific questions."]
    },
    {
      id: 4,
      icon: 'best-practices',
      title: "Prior to this event, you should:",
      description: [
        "Bullet point lorem ipsum dolor 1",
        "Bullet point lorem ipsum dolor 2",
        "Bullet point lorem ipsum dolor 3"
      ]
    },
    {
      id: 5,
      icon: 'international',
      title: "Languages supported:",
      description: [
        "Disponible en español",
        "Chinese subtitles and downloadable materials available (set subtitles to Chinese)"
      ]
    },
    {
      id: 6,
      icon: 'platform',
      title: "Topics included:",
      tags: ["Branding", "Online marketing", "Social media"],
    },
  ]

  const videoEle = videoRef.current;
  const handlePlayPause = () => {
    if (videoEle.paused) {
      videoEle.play();
      
      setIsButtonVisible(false);
      setShowControls(true)
      videoEle.focus();
    } else {
      videoEle.pause();
     
      setIsButtonVisible(true);
      setShowControls(false)
    }
  };

  const handleVideoPlay = () => {
    setIsButtonVisible(false);
   
    setShowControls(true)
    videoEle.focus();
  };

  const handleVideoPause = () => {
    setIsButtonVisible(true);
    
    setShowControls(false)
    videoEle.focus();
  };

  const handleVideoEnd = () => {
   
    setIsButtonVisible(true);
    setShowControls(false)
    videoEle.focus();
  };

  const handleMouseEnter = () => {
    if (!videoEle.paused) {
      setShowControls(true);
      videoEle.focus();
    }
  };

  const handleMouseLeave = () => {
    //setShowControls(false);
    videoEle.focus();
  };

  useEffect(() => {
    if (!currentCourse) return;
    const runAsync = async () => {
    const fifteenMinutes = 15 * 60 * 1000;
    let eventType = '';
    if (currentCourse.tags?.indexOf('Group Session') != -1) {
      eventType = 'Group Session'.toLowerCase().replace(/[^a-z0-9\s]/g, '').split(' ').join('').trim() ?? null;
    } else if (currentCourse.tags?.indexOf('Workshop/Networking') != -1) {
      eventType = 'Workshop/Networking'.toLowerCase().replace(/[^a-z0-9\s]/g, '').split(' ').join('').trim() ?? null;
    } else if (currentCourse.tags?.indexOf('Office Hours') != -1) {
      eventType = 'Office Hours'.toLowerCase().replace(/[^a-z0-9\s]/g, '').split(' ').join('').trim() ?? null;
    } else if (currentCourse.tags?.indexOf('Community') != -1) {
      eventType = 'Community'.toLowerCase().replace(/[^a-z0-9\s]/g, '').split(' ').join('').trim() ?? null;
    }
    //let eventType = formattedCurrentEvent?.type?.toLowerCase().replace(/[^a-z0-9\s]/g, '').split(' ').join('').trim() ?? null;
    setPreviewURL({
      vidURL: isInPersonEvent
        ? id
          // ? `${global.config.AEM_URL}inperson_evt_details/${lng}/preview/videos/${id}.mp4`
          ? await getImageToBeRendered("eventDetails", screenType, "inPersonEvents", lng, id,"","",'crsPreVid')
          : null
        : eventType
          // ? `${global.config.AEM_URL}event_details/${lng}/preview/videos/${eventType}.mp4`
          ? await getImageToBeRendered("eventDetails", screenType, "events", lng, id,eventType,"",'evntPreVid')
          : null,
      imgURL: isInPersonEvent
        ? await getImageToBeRendered("eventDetails", screenType, "inPersonEvents", lng, id)  
        : await getImageToBeRendered("eventDetails", screenType, "events", lng, id)
    });
    if (((currentCourse?.dateStart - Date.now()) <= fifteenMinutes) && (currentCourse?.dateStart >= Date.now())) {
      setEventInFifteen(true);
    } else {
      setEventInFifteen(false);
    }
    // setPreviewDetails(eventCxAemData?.preVidDetails?.filter(detail => detail.eventType === eventType));
    // if (previewDetails?.length > 0 && isBefore) {
    //   document.getElementById('prev-title').innerHTML = previewDetails?.[0]?.preVidTitle;
    //   document.getElementById('prev-desc').innerHTML = previewDetails?.[0]?.preVidDesc;
    // }
    const detailsPreview = eventCxAemData?.preVidDetails?.filter(detail => detail.eventType === eventType) || []
    setPreviewDetails(detailsPreview);
    if (detailsPreview?.length > 0 && isBefore) {
      const prevTitleEl = document.getElementById('prev-title');
      const prevDescEl = document.getElementById('prev-desc');
      if (prevTitleEl)
        prevTitleEl.innerHTML = detailsPreview?.[0]?.preVidTitle;
      if (prevDescEl)
        prevDescEl.innerHTML = detailsPreview?.[0]?.preVidDesc;
    }

    // seo logic implementation

 const preloadImage = (url) => {
    return new Promise((resolve, reject) => {
      if (!url || url.trim() === "") return reject(new Error("Invalid URL"));
      const img = new Image();
      img.src = url;
      const timeout = setTimeout(() => {
        // img.src = ""; // Stop the browser from continuing to load
        // reject(new Error("Timeout"));
      }, 2000);
      
      img.onload = () => {
        clearTimeout(timeout);
        resolve(url);
      };
      img.onerror = () => {
        clearTimeout(timeout);
        reject(new Error("Image Load failed"));
      };
    });
  };
  const defaultImage = isInPersonEvent
  ? await getImageToBeRendered("eventDetails", screenType, "inPersonEvents", lng, id,"","",'evntDetPvwImg')
  : await getImageToBeRendered("eventDetails", screenType, "events", lng, id,"","",'evntDetPvwImg');  

   const loadImage = async () => {
   
    setImageUrl('');

    try {
      // 1.Call method with "avif" parameter
      try {
       const avifUrl = await getImageToBeRendered('eventDetails', screenType, isInPersonEvent ? 'inPersonEvents' : 'events' , lng, id, '', imgFormat,'evntDetPvwImg');
        await preloadImage(avifUrl);
        setImageUrl(avifUrl);
        return; 
      } catch (e) {
        console.warn("AVIF failed, trying PNG...");
      }

      // 2. Call method without "avif" (defaults to PNG)
      // try {
      //   const pngUrl =  getImageToBeRendered('eventDetails', screenType, isInPersonEvent ? 'inPersonEvents' : 'events' , lng, id, '');
      //   await preloadImage(pngUrl);
      //   setImageUrl(pngUrl);
      //   return; 
      // } catch (e) {
      //   console.warn("PNG failed, trying Fallback Data...");
      // }

      // 3. LMS image as fallback
      const dataFallbackUrl = currentCourse?.bannerUrl || currentCourse?.imageUrl;
      if (dataFallbackUrl) {
        try {
          await preloadImage(dataFallbackUrl);
          setImageUrl(dataFallbackUrl);
          return;
        } catch (e) {
          console.warn("fallback image failed to load.");
        }
      }

      // setting ulr as empty string
      setImageUrl('');

    } catch (error) {
     
      setImageUrl('');
    } finally {
      
    }
  };

  loadImage();

    //


    const img = new Image();
    img.src = defaultImage;

    img.onload = () => {
      setPosterImage(defaultImage);
    };

    img.onerror = () => {
      setPosterImage(currentCourse?.bannerUrl || currentCourse?.imageUrl);
    };

    // const img2 = new Image();
    // img2.src = defaultImage;

    // img2.onload = () => {
    //   // setImageUrl(defaultImage);
    // };

    // img2.onerror = () => {
    //   setImageUrl(currentCourse?.bannerUrl || currentCourse?.imageUrl);
    // };


  };
    runAsync();
  
  }, [currentCourse,isInPersonEvent]);

  useEffect(() => {
    if (relSectionPillData) {
      if ((relSectionPillData?.length <= 1 && relSectionPillData[0]?.label === "All")) {
        setHideRelSection(true);
      }else{
        setHideRelSection(false);
      }
    }
    else {
      setHideRelSection(false);
    }
   }, [relSectionPillData]);

  return (
    <div className='CourseDetailsBody'>
      <div>
        <div>
          <nav className='nav_tabs'>
            <div className='nav_tabs_inner'>
              {tabs?.map((tab) => (
                <div
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id, tab.ref)}
                  className={`tab_button ${activeTab === tab.id ? 'active' : ''}`}
                  tabIndex={0}
                  role="button"
                  aria-label={`${tab?.name} tab`} // Describes the purpose of the tab
                  aria-selected={activeTab === tab?.id} // Indicates the selected state
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      handleTabClick(tab?.id, tab?.ref);
                    }
                  }} // keyboard navigation
                >
                  <Title size='small' color={activeTab === tab.id ? '#000' : '#6F7171'} bold>{tab.name}</Title>
                </div>
              ))}
            </div>
          </nav>
        </div>

        {(!isAfter && !(isRecorded && isBefore)) && (
          <section id="preview" ref={previewRef} className='mt-8X'>
            <Title size='large' bold>Event preview.</Title>
            <div className='mt-8X sm-mt-6X'>
              <EventPreview isInPersonEvent={isInPersonEvent} currentEvent={currentCourse} eventCxAemData={eventCxAemData} eventPreviewCardData={eventPreviewCardData} />
            </div>
          </section>
        )}
        {(isRecorded && (isBefore || isAfter)) && (
          <section id="overview" ref={overviewRef} className='mt-8X'>
            <Title size='large' bold>Recorded event overview.</Title>
            <div className='mt-8X sm-mt-6X'>
              <EventPreview isInPersonEvent={isInPersonEvent} currentEvent={formattedCurrentEvent} eventCxAemData={eventCxAemData} eventPreviewCardData={eventPreviewCardData} />
            </div>
          </section>
        )}

        {!isAfter && <section id="details" ref={detailsRef} className='mt-8X pv-8X sm-pv-4X'>
          <Title size='large' bold>{isRecorded ? eventCxAemData?.detailstab?.recEventDetLbl : eventCxAemData?.detailstab?.heading}</Title>
          <CourseDetailsSection isInPersonEvent={isInPersonEvent} detailsRef={detailsRef} eventCxAemData={eventCxAemData} currentCourse={currentCourse} courseDetailsAEMData={eventCxAemData?.detailstab} coursePreviewCardData={eventPreviewCardData} forEvent={true} isAfter={isAfter} allIPEventsWithTimezone={allIPEventsWithTimezone}/>
        </section>}
        {!currentCourse?.tags?.includes(TAG_RECORDED_EVENTS) && hideRelSection == false &&
          <section id="related" ref={relatedRef} className='mt-8X'>
            { !hideRelSection && <Title size='large' bold>{decodeHTML(eventCxAemData?.relatedsection?.relsectitle)}</Title>}
            {allCourses && allEventsWithTimeZone && allQuickTips && <div className='mt-8X sm-mt-6X'>
              <RelatedSection sectionKey={'detSecCards'} isInPersonEvent={isInPersonEvent} aemOffersContentForHeading={aemOffersContentForHeading} selectedTopics={selectedTopics} topicEnEsMaping={topicEnEsMaping} currentCourse={currentCourse} courseType={courseType} allCourses={allCourses} allQuickTips={allQuickTips} allEventsAllWithTimeZone={allEventsWithTimeZone} courseCxAemData={eventCxAemData} offersMock={offersMock} onUpdate={setRelSectionPillData}/>
            </div>}
          </section>}

        {isAfter && <section id="details" ref={detailsRef} className='mt-8X pv-8X sm-pv-4X'>
          <Title size='large' bold>{isRecorded ? eventCxAemData?.detailstab?.recEventDetLbl : eventCxAemData?.detailstab?.heading}</Title>
          <CourseDetailsSection allEventsWithTimeZone={allEventsWithTimeZone} allIPEventsWithTimezone={allIPEventsWithTimezone} isInPersonEvent={isInPersonEvent} eventCxAemData={eventCxAemData} currentCourse={currentCourse} courseDetailsAEMData={eventCxAemData?.detailstab} coursePreviewCardData={eventPreviewCardData} forEvent={true} isAfter={isAfter} />
        </section>}

        {(isAfter && !(isRecorded && isBefore)) && (
            <div className='mt-8X sm-mt-6X'>
              <EventPreview isInPersonEvent={isInPersonEvent} currentEvent={currentCourse} eventCxAemData={eventCxAemData} eventPreviewCardData={eventPreviewCardData} />
            </div>
        )}

        {currentCourse?.tags?.includes(TAG_RECORDED_EVENTS) && (isDuring || isBefore) && 
          <section id="details" ref={detailsRef} className='mt-8X pv-8X sm-pv-4X'>
          <Title size='large' bold>{isRecorded ? eventCxAemData?.detailstab?.recEventDetLbl : eventCxAemData?.detailstab?.heading}</Title>
          <CourseDetailsSection detailsRef={detailsRef} eventCxAemData={eventCxAemData} currentCourse={currentCourse} courseDetailsAEMData={eventCxAemData?.detailstab} coursePreviewCardData={eventPreviewCardData} forEvent={true} isAfter={isAfter} allIPEventsWithTimezone={allIPEventsWithTimezone}/>
        </section>}

        {currentCourse?.tags?.includes(TAG_RECORDED_EVENTS) && 
          <section id="related" ref={relatedRef} className='mt-8X'>
            <Title size='large' bold>{decodeHTML(eventCxAemData?.relatedsection?.relsectitle)}</Title>
            {allCourses && allEventsWithTimeZone && allQuickTips && <div className='mt-8X sm-mt-6X'>
              <RelatedSection sectionKey={'detSecCards'} aemOffersContentForHeading={aemOffersContentForHeading} selectedTopics={selectedTopics} topicEnEsMaping={topicEnEsMaping} currentCourse={currentCourse} courseType={courseType} allCourses={allCourses} allQuickTips={allQuickTips} allEventsAllWithTimeZone={allEventsWithTimeZone} courseCxAemData={eventCxAemData} offersMock={offersMock} />
            </div>}
          </section>
        }

        {<section id="support" ref={supportRef} className='mt-8X pt-8X sm-pt-4X sm-mt-6X'>
          {aemSupportData && <Helmet>
            <link
              href={`${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}${global.config.aemUrlEnv === "QA1" ? '/QA1' : ''}${aemConfigData?.minifiedPath || ''}/css/courseSupport${aemConfigData?.minifiedExt || ''}.css`}
              rel='stylesheet'
              type='text/css'
            ></link>
          </Helmet>}
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(aemSupportData),
            }}
          />
        </section>}
      </div>
      <div className='right_container'>
        <div className='width-100' ref={widgetRef} id="widget">
          {!isInPersonEvent ? <EventWidget isAfter={isAfter} isBefore={isBefore} isDuring={isDuring} isRecorded={isRecorded} currentEvent={currentCourse} eventCxAemData={eventCxAemData} topicEnEsMaping={topicEnEsMaping}/> :
          <InPersonEventWidget eventCxAemData={eventCxAemData} currentEvent={currentCourse} eventStatus={eventStatus}/>}
        </div>

        {/* codefor virtual events */}
        
        {isBefore && !isRecorded && !eventInFifteen && !isInPersonEvent && <div class="width-100" ref={videoGARef} id='video'>
          {(!videoError && previewURL.vidURL) ? (
            <figure class="previewVideo">
            <div class="video-container"
            tabIndex={0}
            aria-label={eventCxAemData?.preVidGrpAccTxt ?? null}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                videoRef.current.focus();
              }
            }}
            role="group"
            >
            <video id="myVideo" 
              ref={videoRef}
              onPlay={handleVideoPlay}
              onPause={handleVideoPause}
              onEnded={handleVideoEnd}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              controls={showControls}
              poster={posterImage} 
              onError={(e) => {
                e.target.onerror = null;
                setVideoError(true)
                }
              } 
              aria-label={eventCxAemData?.preVidGrpAccTxt ?? null}
            >
              <source src={previewURL?.vidURL} type="video/mp4"></source>
            </video>
            {isButtonVisible && (<button id="playButton" class="play-button" onClick={handlePlayPause} aria-label={eventCxAemData?.preVidAccTxt} tabIndex={0} role='button'><Icon name={eventCxAemData?.playBtnIcon}></Icon></button>)}
            </div>
            {previewDetails?.length>0 && <figcaption>
                <div id='prev-title'><Title 
                    size="Small" 
                    bold={true} 
                    color="#000000">{decodeHTML(previewDetails?.[0]?.preVidTitle)}</Title></div>
                <p id='prev-desc'><Body 
                    size="Small" 
                    bold={false} 
                    color="#000000">{decodeHTML(previewDetails?.[0]?.preVidDesc)}</Body></p>
              </figcaption>}
            </figure>
          ) : (
            <img className="right_container_img" src={imageUrl} />
          )}  
        </div>}

        {/* code for in person events */}
        {isInPersonEvent && <div>
          <div className="width-100 video-wrapper" ref={videoGARef} id='video'>
            {(!videoError && previewURL.vidURL) ? (
              <figure className="previewVideo">
                <div className="video-container">
                  <video id="myVideo"
                    ref={videoRef}
                    onPlay={handleVideoPlay}
                    onPause={handleVideoPause}
                    onEnded={handleVideoEnd}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    controls={showControls}
                    poster={posterImage}
                    onError={(e) => {
                      e.target.onerror = null;
                      setVideoError(true)
                      }
                    } 
                  >
                    <source src={previewURL?.vidURL} type="video/mp4"></source>
                  </video>
                  {isButtonVisible && (<button id="playButton" className="play-button" onClick={handlePlayPause}><Icon name={eventCxAemData?.playBtnIcon}></Icon></button>)}
                </div>
                {previewDetails?.length > 0 && <figcaption>
                  <div id='prev-title'></div>
                  <p id='prev-desc'></p>
                </figcaption>}
              </figure>
            ) : (
              imageUrl && (
                <img className="right_container_img" src={imageUrl} />)
            )}
          </div>
          <div className='n-displayFlex mt-8X'>
            <Icon size='XLarge' name='location' />
            <div className='ml-3X'>
              <Title size='small' bold>{eventCxAemData?.locationTitle}</Title>
              <div className='pt-2X'>
              {currentInPersonEvent?.modules?.[0]?.inPersonLocation?.venue && (
                <Body size='large'>{currentInPersonEvent?.modules[0]?.inPersonLocation?.venue}</Body>)}
              {currentInPersonEvent?.modules?.[0]?.inPersonLocation?.address && (
                <Body size='large'>{currentInPersonEvent?.modules[0].inPersonLocation?.address}</Body>)}
              {(currentInPersonEvent?.modules?.[0]?.inPersonLocation?.city || currentInPersonEvent?.modules?.[0]?.inPersonLocation?.state || currentInPersonEvent?.modules?. [0]?.inPersonLocation?.zipCode) && (
               <Body size='large'>{currentInPersonEvent?.modules[0]?.inPersonLocation?.city}, {currentInPersonEvent?.modules[0]?.inPersonLocation?.state} {currentInPersonEvent?.modules[0]?.inPersonLocation?.zipCode} </Body>)}
              </div>
              <div className='pt-3X'>
                <Body size='small'>
                  <TextLink
                    type="standAlone"
                    surface="light"
                    size="small" 
                    disabled={false}
                    onClick={(e) => handleViewOnMapClick(e, currentInPersonEvent?.modules[0]?.inPersonLocation)}>
                    {decodeHTML(eventCxAemData?.viewOnMapLbl)}
                  </TextLink>
                </Body>
              </div>
            </div>
          </div>
        </div>}
      </div>
    </div>
  )
}

export default EventDetailsBody